import styled, { css } from 'styled-components'

import { maxWidthGridV2Css } from 'Layout/MaxWidthGridV2/styles'

import { BREAK_POINT_LG, BREAK_POINT_MD } from '@CSSVars/variables'
import { OUTLINE_COLOR } from '@CSSVars/colors'


export const _CollapseContainer = styled.div`
  padding-top: 24px;
  border-top: 1px solid ${OUTLINE_COLOR};
  width: calc(100% - 48px);
  margin: 0 auto;
  label[for="ReadMoreExtra"] {
    ${maxWidthGridV2Css};
    margin-bottom: 24px;
    @media screen and (max-width: ${BREAK_POINT_MD}) {
      width: 100%;
    }
  }

  ${({ isAddressPage }) => (isAddressPage ? `
    @media screen and (max-width: ${BREAK_POINT_LG}) {
      label[for="ReadMoreExtra"] {
        width: calc(100% - 140px);
        max-width: 1160px;
      }
    }
    @media screen and (max-width: ${BREAK_POINT_MD}) {
      label[for="ReadMoreExtra"] {
        width: 100% !important;
        max-width: 708px;
      }
    }
  ` : '')}
`


export const collapseLabelCss = css`
  ${maxWidthGridV2Css};
  display: block;
  width: 100% !important;
  margin: 0 0 24px 0;
`

export const collapseContentCss = css`
  margin-top: 0;
`

